// src/components/achievements/AchievementGrid.tsx
import React from 'react';
import { AchievementCard } from './AchievementCard';
import { UserStats } from '@/types';

interface AchievementGridProps {
  userStats: UserStats;
}

export const AchievementGrid: React.FC<AchievementGridProps> = ({ userStats }) => {
  const achievements = [
    {
      id: 'first-test',
      title: 'First Steps',
      description: 'Complete your first testing session',
      icon: '🎯',
      requirement: 1,
      progress: Math.min(userStats.totalDays, 1),
    },
    {
      id: 'week-warrior',
      title: 'Week Warrior',
      description: 'Maintain a 7-day testing streak',
      icon: '🌟',
      requirement: 7,
      progress: userStats.currentStreak,
    },
    {
      id: 'month-master',
      title: 'Month Master',
      description: 'Maintain a 30-day testing streak',
      icon: '⚡',
      requirement: 30,
      progress: userStats.currentStreak,
    },
    {
      id: 'quarter-champion',
      title: 'Quarter Champion',
      description: 'Maintain a 90-day testing streak',
      icon: '🔥',
      requirement: 90,
      progress: userStats.currentStreak,
    },
    {
      id: 'half-year-hero',
      title: 'Half Year Hero',
      description: 'Maintain a 180-day testing streak',
      icon: '💎',
      requirement: 180,
      progress: userStats.currentStreak,
    },
    {
      id: 'year-legend',
      title: 'Year Legend',
      description: 'Maintain a 365-day testing streak',
      icon: '👑',
      requirement: 365,
      progress: userStats.currentStreak,
    },
    {
      id: 'dedicated-10',
      title: 'First 10!',
      description: 'Complete 10 testing sessions',
      icon: '🎖️',
      requirement: 10,
      progress: userStats.totalDays,
    },
    {
      id: 'dedicated-50',
      title: 'Half Century',
      description: 'Complete 50 testing sessions',
      icon: '🏆',
      requirement: 50,
      progress: userStats.totalDays,
    },
    {
      id: 'dedicated-100',
      title: 'Centurion',
      description: 'Complete 100 testing sessions',
      icon: '🎖️',
      requirement: 100,
      progress: userStats.totalDays,
    },
    {
      id: 'dedicated-250',
      title: 'Elite Tester',
      description: 'Complete 250 testing sessions',
      icon: '🌠',
      requirement: 250,
      progress: userStats.totalDays,
    },
    {
      id: 'dedicated-500',
      title: 'Testing Legend',
      description: 'Complete 500 testing sessions',
      icon: '🔱',
      requirement: 500,
      progress: userStats.totalDays,
    },
    {
      id: 'comeback-kid',
      title: 'Comeback Kid',
      description: 'Restart your streak after breaking it',
      icon: '💪',
      requirement: 1,
      progress: userStats.longestStreak > userStats.currentStreak && userStats.currentStreak > 0 ? 1 : 0,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {achievements.map((achievement) => (
        <AchievementCard
          key={achievement.id}
          title={achievement.title}
          description={achievement.description}
          icon={achievement.icon}
          unlocked={achievement.progress >= achievement.requirement}
          progress={achievement.progress}
          requirement={achievement.requirement}
        />
      ))}
    </div>
  );
};

